import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import AuthProtectedRoute from '../AuthProtectedRoute';

const AgentDashboard = lazy(() => import('../pages/agent/agent-dashboard/index'));
const AgentPaymentDashboard = lazy(() => import('../pages/agent/agent-payment-dashboard'));
const AgentMemberList = lazy(() => import('../pages/agent/agent-member-list'));

const ContactAdvisorForm = lazy(() => import('../pages/forms/contact-advisor-form'));

const MemberDashboard = lazy(() => import('../pages/member/member-dashboard'));
const MemberPaymentDashboard = lazy(() => import('../pages/member/member-payment-dashboard'));

const OwnerDashboard = lazy(() => import('../pages/owner/owner-dashboard'));
const OwnerRealtorGroupCreate = lazy(() => import('../pages/owner/owner-realtor-group-create'));
const OwnerRealtorGroupList = lazy(() => import('../pages/owner/owner-realtor-group-list'));
const OwnerAgentList = lazy(() => import('../pages/owner/owner-agent-list'));
const OwnerMemberList = lazy(() => import('../pages/owner/owner-member-list'));

const OwnerSurityCareList = lazy(() => import('../pages/owner/owner-surity-care-list'));
const OwnerStrategizerList = lazy(() => import('../pages/owner/owner-strategizer-list'));

const AgentSurityCareList = lazy(() => import('../pages/agent/agent-surity-care-list'));
const AgentStrategizerList = lazy(() => import('../pages/agent/agent-strategizer-list'));
const OwnerRealtorUserList = lazy(() => import('../pages/owner/owner-realtor-user-list'));
const AgentsAgentList = lazy(() => import('../pages/agent/agnet-agent-list'));

const AgentRealtorGroupList = lazy(() => import('../pages/agent/agent-realtor-group-list'));
const AgentRealtorUserList = lazy(() => import('../pages/agent/agent-realtor-user-list'));
const StrategizerStart = lazy(() => import('../pages/strategizer/strategizer-start'));
const PaymentSuccess = lazy(() => import('../pages/payments/payment-success'));
const PaymentFailed = lazy(() => import('../pages/payments/payment-fail'));

const protectedRoutes = (
  <Route element={<AuthProtectedRoute />}>
    <Route path="/owner-dashboard" element={<OwnerDashboard />} />
    <Route path="/owner-realtor-group-list" element={<OwnerRealtorGroupList />} />
    <Route path="/owner-realtor-group-create" element={<OwnerRealtorGroupCreate />} />
    <Route path="/owner-agent-list" element={<OwnerAgentList />} />
    <Route path="/owner-member-list" element={<OwnerMemberList />} />
    <Route path="/member-dashboard" element={<MemberDashboard />} />
    <Route path="/member-payment-dashboard" element={<MemberPaymentDashboard />} />
    <Route path="/agent-dashboard" element={<AgentDashboard />} />
    <Route path="/agent-payment-dashboard" element={<AgentPaymentDashboard />} />
    <Route path="/agent-member-list" element={<AgentMemberList />} />

    <Route path="/owner-surity-care-list" element={<OwnerSurityCareList />} />
    <Route path="/owner-strategizer-list" element={<OwnerStrategizerList />} />

    <Route path="/agent-surity-care-list" element={<AgentSurityCareList />} />
    <Route path="/agent-strategizer-list" element={<AgentStrategizerList />} />

    <Route path="/contact-advisor-form" element={<ContactAdvisorForm />} />

    <Route path="/owner-realtor-list" element={<OwnerRealtorUserList />} />

    <Route path="/agent-agent-list" element={<AgentsAgentList />} />
    <Route path="/agent-realtor-group-list" element={<AgentRealtorGroupList />} />
    <Route path="/agent-realtor-user-list" element={<AgentRealtorUserList />} />
    <Route path="/strategizer-start" element={<StrategizerStart />} />
    <Route path="/payment-success" element={<PaymentSuccess />} />
    <Route path="/payment-failed" element={<PaymentFailed />} />
  </Route>
);

export default protectedRoutes;
